/** The LevelLoad mark: seven bars levelling out. Inherits `currentColor`. */
export function BrandMark({ className }: { className?: string }) {
  const heights = [5, 9, 13, 16, 13, 9, 5];
  return (
    <svg
      viewBox="0 0 24 20"
      aria-hidden="true"
      className={className}
      fill="currentColor"
      role="presentation"
    >
      {heights.map((h, i) => (
        <rect key={i} x={1 + i * 3.3} y={18 - h} width={2.2} height={h} rx={0.6} />
      ))}
    </svg>
  );
}
